import * as React from "react";
import { useEffect } from "react";
import { Feature } from "ol";
import { useNomaContext } from "../../Contexts/MapContext";
import { useRegistrationContext } from "../../Contexts/RegistrationContext";
import { ObjectSection } from "./ObjectSection";
import { UserConsentCheck } from "./UserConsent";
import { UploadList } from "../../Forms/UploadList";

export interface ISummaryParams {
    header: ISummaryHeader;
    objectInfoRows: IAliasValue[];
    globalId: string;
    customer: ISection;
    attachments: ISection;
    date: string;
    visiting: IAliasValue;
    footerNote?: string;
}

export interface IObjectSection {
    header: ISummaryHeader;
    objectInfoRows: IAliasValue[];
}
interface ISummaryHeader {
    headerRows: IAliasValue[];
    snapshotBig: string;
    snapshotSmall: string;
}
interface IAliasValue {
    alias: string;
    value: string;
}
interface ISection {
    title: string;
    rows: string[];
}

export const SummarySection = (): JSX.Element => {
    const { registerFeature } = useNomaContext();
    const { setUserConsent, summaryData, setSummaryData, getSummaryJson, attachments } = useRegistrationContext();

    useEffect(() => {
        setUserConsent(false);
        setSummaryData(getSummaryJson());
    }, []);

    useEffect(() => {
        setSummaryData(getSummaryJson());
    }, [attachments]);

    return summaryData ? (
        <>
            <ObjectSection data={summaryData}></ObjectSection>
            <InfoSection params={summaryData} feature={registerFeature} setUserConsent={setUserConsent}></InfoSection>
        </>
    ) : null;
};

interface IInfoSectionProps {
    params: ISummaryParams;
    feature: Feature;
    setUserConsent: CallableFunction;
}
const InfoSection = ({ params, feature, setUserConsent }: IInfoSectionProps): JSX.Element => (
    <>
        <Section classname={"user-data-section"} data={params.customer}></Section>
        {(!feature || feature.get("TYPEOFLEASEGRANTING") !== 5) && (
            <div className="checkmark-section disabled">
                <UserConsentCheck onChange={setUserConsent} defaultChecked={true}></UserConsentCheck>
            </div>
        )}
        {params.attachments ? (
            <AttachmentSection classname={"attachment-section"} data={params.attachments}></AttachmentSection>
        ) : null}
        <div className="date-section">
            <span>{params.date}</span>
        </div>

        <hr />
        <div className="visit-section">
            <div>{params.visiting.alias}</div>
            <div>{params.visiting.value}</div>
        </div>
        {params.footerNote ? <div className="notes-section">{params.footerNote}</div> : null}
    </>
);

const Section = ({ classname, data }: { classname: string; data: ISection }): JSX.Element => (
    <div className={classname}>
        <div className="title">{data.title}</div>
        {data.rows.map((row) => (
            <div className="row" key={data.title + row}>
                {row}
            </div>
        ))}
    </div>
);
const AttachmentSection = ({ classname, data }: { classname: string; data: ISection }): JSX.Element => {
    const { attachments, setAttachments } = useRegistrationContext();

    return (
        <div className={classname}>
            <div className="title">{data.title}</div>
            <UploadList onChange={setAttachments} fileList={attachments}></UploadList>
        </div>
    );
};
